import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { px as _px } from "@terraindigital/static-styles-react";
import React from 'react';
import VisuallyHidden from '../visually-hidden';
const spin = "static-styles-spinner-kf-1mhdd96y";
export interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * A spinner component taken from Chakra-UI.
 * Features same size parameter as Chakra so in most cases should
 * be a drop-in replacement.
 * @alias SpinnerProps
 * */
const Spinner = ({
  size = 'md'
}: SpinnerProps): JSX.Element => {
  const foundSize = {
    xs: '12px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px'
  }[size];
  return <div className="spinner__div-0idjo7" style={{
    "--static-styles-2q6qtcpu_width": _px(foundSize),
    "--static-styles-2tqeur6o_height": _px(foundSize)
  }}>
            <VisuallyHidden>Loading...</VisuallyHidden>
        </div>;
};
export default Spinner;